import { LoadingButton } from '@mui/lab';
import { Alert, Typography } from '@mui/material';
import { Stack } from '@mui/system';
import { skipToken } from '@reduxjs/toolkit/dist/query';
import useSnackbar from 'hooks/useSnackbar';
import { useCallback } from 'react';
import { useSelector } from 'store';
import { useGetOrgQuery, useUpdateOrgMutation } from 'store/slices/apiV1/org';
import { useGetInvoicedLinkQuery } from 'store/slices/apiV1/purchasing';
import { handleErr, copyClipboard } from 'utils/functions';

export default function OnboardingAlert() {
  const { dispatchSuccessSnackbar, dispatchErrorSnackbar } = useSnackbar();

  const { activeOrgId } = useSelector((state) => state.org);
  const {
    data: org,
    isSuccess: isFetchOrgSuccess,
    isLoading: isLoadingOrg,
  } = useGetOrgQuery(activeOrgId ?? skipToken);
  const { data: invoicedLink, isLoading: isLoadingLink } =
    useGetInvoicedLinkQuery(org?.createdFrom ? skipToken : undefined);
  const [updateOrg, { isLoading: isUpdatingOrg }] = useUpdateOrgMutation();
  const onEnable = useCallback(async () => {
    try {
      await updateOrg({
        orgId: activeOrgId!,
        payload: { onboardingRequired: false },
      }).unwrap();
    } catch (err) {
      handleErr(err, (errMessage: string) => {
        dispatchErrorSnackbar(errMessage);
      });
    }
  }, [updateOrg, activeOrgId, dispatchErrorSnackbar]);

  const onCopyInvoicedLink = useCallback(async () => {
    if (!invoicedLink?.url) return;
    try {
      await copyClipboard(invoicedLink?.url);
    } catch (err) {
      handleErr(err, (errMessage: string) => {
        dispatchErrorSnackbar(errMessage);
      });
    }
  }, [invoicedLink?.url, dispatchErrorSnackbar]);
  return (
    <Alert
      severity="info"
      action={
        <Stack direction="column" spacing={1}>
          <LoadingButton
            variant="outlined"
            onClick={onCopyInvoicedLink}
            loading={isLoadingLink}
          >
            Copy Invoiced link to clipboard
          </LoadingButton>
          <LoadingButton
            variant="contained"
            loading={isUpdatingOrg}
            onClick={onEnable}
          >
            Enable Org
          </LoadingButton>
        </Stack>
      }
    >
      <Typography variant="body1">
        This org is locked until an onboarding call is completed.
      </Typography>
    </Alert>
  );
}
